(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ate-home-layout"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('ate-category-carousel')) {
  customElements.define('ate-category-carousel', class extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.ate-category-carousel__track');
      this.previous = this.querySelector('[data-category-previous]');
      this.next = this.querySelector('[data-category-next]');
      if (!this.track || !this.previous || !this.next) return;
      this.events = new AbortController();
      const options = { signal: this.events.signal };
      const update = () => {
        const end = this.track.scrollWidth - this.track.clientWidth;
        this.previous.disabled = this.track.scrollLeft <= 1;
        this.next.disabled = this.track.scrollLeft >= end - 1;
      };
      const move = (direction) => {
        const cards = this.track.children;
        const step = cards.length > 1 ? cards[1].offsetLeft - cards[0].offsetLeft : this.track.clientWidth;
        this.track.scrollBy({ left: direction * step, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
      };
      this.previous.addEventListener('click', () => move(-1), options);
      this.next.addEventListener('click', () => move(1), options);
      this.track.addEventListener('scroll', update, { ...options, passive: true });
      this.track.addEventListener('keydown', (event) => {
        if (event.target !== this.track) return;
        if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
          event.preventDefault();
          move(event.key === 'ArrowLeft' ? -1 : 1);
        }
        if (event.key === 'Home' || event.key === 'End') {
          event.preventDefault();
          this.track.scrollTo({ left: event.key === 'Home' ? 0 : this.track.scrollWidth, behavior: 'instant' });
        }
      }, options);
      this.observer = new ResizeObserver(update);
      this.observer.observe(this.track);
      this.querySelector('.ate-category-carousel__controls').hidden = false;
      update();
    }
    disconnectedCallback() {
      this.events?.abort();
      this.observer?.disconnect();
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ate-support-badge"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ate-support-badge')) {
    customElements.define('ate-support-badge', class extends HTMLElement {
      connectedCallback() {
        this.formatter = new Intl.DateTimeFormat('en-US', { timeZone: 'America/Chicago', hour: '2-digit', minute: '2-digit', hourCycle: 'h23' });
        this.updateStatus = () => {
          const parts = this.formatter.formatToParts(new Date());
          const hour = Number(parts.find(part => part.type === 'hour').value);
          const open = hour >= 9 && hour < 17;
          const value = String(open);
          if (this.dataset.open !== value) {
            this.dataset.open = value;
            this.querySelector('.ate-support__status').textContent = open ? this.dataset.openLabel : this.dataset.closedLabel;
          }
        };
        this.updateStatus();
        this.timer = window.setInterval(this.updateStatus, 1000);
        document.addEventListener('visibilitychange', this.updateStatus);
        window.addEventListener('pageshow', this.updateStatus);
      }
      disconnectedCallback() {
        window.clearInterval(this.timer);
        document.removeEventListener('visibilitychange', this.updateStatus);
        window.removeEventListener('pageshow', this.updateStatus);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
